import React, { useState, useEffect } from "react";

const Code = () => {
  const [activityData, setActivityData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Define the API endpoint URL
  const FORM_ENDPOINT = "https://api.pebble.solutions/v5/activity/01HG5HD3J6K4E7TAWA7DAP10HZ";

  useEffect(() => {
    // Define an asynchronous function to fetch data
    const fetchData = async () => {
      try {
        const response = await fetch(FORM_ENDPOINT);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setActivityData(data);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, []); // The empty dependency array ensures this effect runs only once

  return (
  <div className="pt-0 mb-3">
    {loading ? (
      <p>Loading...</p>
    ) : error ? (
      <p>Error: {error.message}</p>
    ) : (
      <>
        <h1>{activityData.name}</h1>
        <ul>
          {activityData.groups.map((group, index) => (
            <li key={index}>
              {group.name}{' (30 min) dispo : '}
              {group.places_left}/{group.places}{' - '}
              {group.places_left > 0 ? (
                <a href={`?code=${group.code}` + '&activite=01HG5HD3J6K4E7TAWA7DAP10HZ'}>Inscription</a>
              ) : (
                <span>complet !</span>
              )}
            </li>
          ))}
        </ul>
      </>
    )}
  </div>
);
};

export default Code;
